import { setTablePagination } from '@/state/reducers/tableSettingSlice';
import { DepositWithdrawalRequestsReturn } from '@/types/sso';
import useContextMenu from '@/utils/hooks/useContextMenu';
import useLanguage from '@/utils/hooks/useLanguage';
import usePortalRecentTransactionsTable from '@/utils/hooks/usePortalRecentTransactionsTable';
import cn from 'classnames';
import { useCallback, useState } from 'react';
import { MdRefresh } from 'react-icons/md';
import CurrentTradeDate from '../common/CurrentTradeDate';
import PortalVirtualizedTable, { PortalTableGeneralProps } from '../table/PortalVirtualizedTable';
import TablePagination from '../table/TablePagination';

export interface PortalRecentTransactionsRow {}

export interface PortalRecentTransactionsTableProps extends PortalTableGeneralProps {
    mode: 'bank' | 'crypto';
    data?: DepositWithdrawalRequestsReturn;
    setOffset: (offset: number) => void;
}

export type PositionFilter = 'Show All' | 'Hide Closed Positions';

const PortalRecentTransactionsTable = (props: PortalRecentTransactionsTableProps) => {
    const { isLoading } = props;

    const lang = useLanguage();
    const [selectedRow, setSelectedRow] = useState<PortalRecentTransactionsRow>();

    const contextMenu = useContextMenu();

    const { debouncedTableInstance } = usePortalRecentTransactionsTable(props);

    const onContextMenu = useCallback(
        (event, request) => {
            setSelectedRow(request);
            contextMenu.handleOpenContextMenu(event);
        },
        [contextMenu]
    );

    return (
        <div className="flex flex-col gap-1 bg-brand-background-dark p-4 sm:p-6 py-4 border border-brand-neutral-700 text-brand-text rounded-md overflow-hidden max-h-[600px]">
            <div className="flex flex-col h-full gap-4">
                <div className="flex flex-wrap gap-2 justify-between">
                    <div className="">{lang.portal.recentRequestedTransactions}</div>
                    <div
                        className={cn('border border-brand-neutral-700 rounded-md p-1.5 cursor-pointer', {
                            'hover:bg-brand-primary': !props.isLoading
                        })}
                        onClick={() => {
                            if (!props.isLoading) {
                                props.mutate();
                            }
                        }}>
                        <MdRefresh
                            className={cn('w-4 h-4', {
                                'animate-spin text-brand-neutral-400': props.isLoading
                            })}
                        />
                    </div>
                </div>
                <PortalVirtualizedTable tableInstance={debouncedTableInstance} isLoadingTableContent={isLoading} />
                <div className="flex flex-wrap-reverse gap-2 items-center justify-between">
                    <CurrentTradeDate />
                    <TablePagination
                        tableInstance={debouncedTableInstance}
                        getPageSize={(pageSize) => setTablePagination(pageSize)}
                    />
                </div>
            </div>
        </div>
    );
};

export default PortalRecentTransactionsTable;
